module.exports = __webpack_public_path__ + "static/img/contact-image.e04a32c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact-image.jpg
// module id = zQXW
// module chunks = 0